import {
  IAddressCreateProps,
  IAddressProps,
  IAddressUpdateProps,
} from '../AddressService/types';
import { IRecognitionGroupSimpleProps } from './Group/types';
import { IFacialControllerSimpleProps } from '../Devices/Recognition/Controllers/types';
import { ISchoolClassSimpleProps } from '../SchoolClass/types';
import { IDeviceGroupProps } from '../DeviceGroupService/types';

export enum IRecognitionTypes {
  GENERAL = 'GeneralRecognitionEntity',
  CUSTOMER = 'CustomerRecognitionEntity',
  STUDENT = 'StudentRecognitionEntity',
  RESPONSIBLE = 'ResponsibleRecognitionEntity',
  QUICK_RELEASE = 'QuickReleaseRecognitionEntity',
}

export interface IRecognitionTypeOption {
  label: string;
  value: IRecognitionTypes;
}

export interface IRecognitionProps {
  id: number;
  name: string;
  cpf?: string;
  cnpj?: string;
  image: string;
  validUntil?: Date;
  phone: string;
  vehicleTags?: string[] | null;
  accessCardTags?: string[] | null;
  type?: string | null;
  uc?: string[] | null;
  recognitionGroups?: IRecognitionGroupSimpleProps[];
  facialControllers?: IFacialControllerSimpleProps[];
  deviceGroups?: IDeviceGroupProps[];
  classId?: number[] | null;
  address?: IAddressProps;
}

export interface IRecognitionSimpleProps {
  id?: number;
  name: string;
  isTemporary: boolean;
  isActive?: boolean;
  cpf?: string;
  cnpj?: string;
  userId?: string;
  image?: string | Blob;
  discriminator: IRecognitionTypes;
  validUntil?: Date;
  registration?: string;
  facialControllersIds?: number[];
  deviceGroupIds?: number[] | null;
  recognitionGroupIds?: number[] | null;

  phone?: string;
  vehicleTags?: string[] | null;
  accessCardTags?: string[] | null;
  type?: string | null;
  uc?: string[] | null;

  // Presentes apenas quando discriminator for IRecognitionTypes.STUDENT
  canGoOut?: boolean | null;
  temporaryReleaseUntil?: string | null;
}

export interface IRecognitionCreateProps {
  name: string;
  cpf?: string;
  cnpj?: string;
  validUntil?: string | null;
  phone?: string;
  vehicleTags?: string[] | null;
  accessCardTags?: string[] | null;
  recognitionGroupIds: number[] | null;
  facialControllerIds: number[] | null;
  deviceGroupIds?: number[] | null;

  address?: IAddressCreateProps | null;
  file?: Blob | string;
  type?: string | null;
  uc?: string[] | null;
}

export interface IRecognitionUpdateProps {
  name: string;
  cpf?: string;
  cnpj?: string;
  image?: string;
  validUntil?: string | null;
  phone?: string;
  vehicleTags?: string[] | null;
  accessCardTags?: string[] | null;
  recognitionGroupIds: number[] | null;
  facialControllerIds: number[] | null;
  deviceGroupIds?: number[] | null;
  address?: IAddressUpdateProps | null;
  file?: Blob | string;
  type?: string | null;
  uc?: string[] | null;
}

export interface IRecognitionFilterParams {
  search?: string;
  discriminator?: IRecognitionTypes;
  isActive?: boolean;
  temporary?: boolean;
}

export interface IRecognitionDeleteParams {
  id: number;
  type: IRecognitionTypes;
}

/**
 * Payload da troca de tipo de cadastro. Contrato proprio, diferente do update:
 * so o minimo estrutural pra virar o tipo novo. O resto dos campos (grupos,
 * controladores, telefone etc) e preenchido depois no form normal do tipo
 * destino, que ja vem com o que sobreviveu na troca.
 */
export interface IRecognitionChangeTypeProps {
  targetDiscriminator: IRecognitionTypes;
  name?: string;
  cpf?: string;

  // Copiados manualmente entre Estudante/Responsavel (colunas distintas no banco).
  gender?: string | null;
  schoolBoardIds?: number[] | null;
  schoolTransportationIds?: number[] | null;

  // Exclusivos de Estudante.
  registration?: string;
  birthDate?: string | null;

  // Exclusivos de Responsavel.
  email?: string;
  password?: string;
}

export interface IRecognitionChangeTypeParams {
  id: number;
  data: IRecognitionChangeTypeProps;
}
